export default "__VITE_ASSET__9612fa7b__"